(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vc-notice][data-vc-dismissible]').forEach(function (bar) {
      var key = bar.getAttribute('data-vc-notice');
      try { if (window.sessionStorage.getItem(key)) { bar.hidden = true; return; } } catch (e) {}
      var btn = bar.querySelector('[data-vc-notice-close]');
      if (btn) btn.addEventListener('click', function () { bar.hidden = true; try { window.sessionStorage.setItem(key, '1'); } catch (e) {} });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-brew-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.vc-brew').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-vc-method]');
      var panels = root.querySelectorAll('[data-vc-panel]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var id = t.getAttribute('data-vc-method');
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-vc-panel') !== id; });
          tabs.forEach(function (b) { var on = b === t; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-drop-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.vc-gate');
    if (!root || !window.crypto || !window.crypto.subtle) return;
    var form = root.querySelector('[data-vc-gate-form]');
    var input = root.querySelector('[data-vc-gate-input]');
    var field = root.querySelector('[data-vc-gate-field]');
    var error = root.querySelector('[data-vc-gate-error]');
    var expected = root.getAttribute('data-hash');
    var prefix = root.getAttribute('data-prefix');
    var pagesBase = root.getAttribute('data-pages');
    var key = root.getAttribute('data-key');

    function sha256(text) {
      return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
        return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (input.value || '').trim().toLowerCase();
      if (!code) return;
      sha256(code).then(function (hash) {
        if (hash !== expected) {
          field.classList.add('vc-field--error');
          error.hidden = false;
          input.focus();
          return;
        }
        return sha256('vc-drop|' + code).then(function (h2) {
          try { window.localStorage.setItem(key, '1'); } catch (err) {}
          window.location.href = pagesBase + prefix + '-' + h2.slice(0, 10);
        });
      });
    });
    input.addEventListener('input', function () { field.classList.remove('vc-field--error'); error.hidden = true; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-hero-bleed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vc-bleed]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-vc-slide]');
      var count = slides.length; if (count < 2) return;
      var current = 1, timer = null;
      var counter = root.querySelector('[data-vc-current]');
      function go(n) {
        current = ((n - 1 + count) % count) + 1;
        slides.forEach(function (s) { var on = s.getAttribute('data-vc-slide') === String(current); s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
        if (counter) counter.textContent = ('0' + current).slice(-2);
      }
      function restart() { if (timer) clearInterval(timer); if (root.getAttribute('data-autoplay') === 'true') { var ms = parseInt(root.getAttribute('data-interval') || '6000', 10); timer = setInterval(function () { go(current + 1); }, Math.max(3000, ms)); } }
      var prev = root.querySelector('[data-vc-prev]'), next = root.querySelector('[data-vc-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(current + 1); restart(); });
      root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { go(current - 1); restart(); } if (e.key === 'ArrowRight') { go(current + 1); restart(); } });
      var startX = null;
      root.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) { if (startX === null) return; var dx = e.changedTouches[0].clientX - startX; startX = null; if (Math.abs(dx) > 40) { go(dx < 0 ? current + 1 : current - 1); restart(); } }, { passive: true });
      root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      root.addEventListener('mouseleave', restart);
      restart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-lot-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.vc-lots').forEach(function (root) {
      var filterBtns = root.querySelectorAll('[data-vc-filter]');
      var viewBtns = root.querySelectorAll('[data-vc-view]');
      var layouts = root.querySelectorAll('[data-vc-layout]');

      function setView(view) {
        if (!root.querySelector('[data-vc-layout="' + view + '"]')) view = 'grid';
        layouts.forEach(function (el) { el.hidden = el.getAttribute('data-vc-layout') !== view; });
        viewBtns.forEach(function (b) {
          var on = b.getAttribute('data-vc-view') === view;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        try { window.localStorage.setItem('vc-view', view); } catch (e) {}
      }
      function setFilter(f) {
        filterBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-vc-filter') === f); });
        root.querySelectorAll('.vc-card').forEach(function (card) {
          var avail = card.getAttribute('data-vc-available') === 'true';
          card.hidden = f === 'available' ? !avail : f === 'gone' ? avail : false;
        });
      }
      filterBtns.forEach(function (b) { b.addEventListener('click', function () { setFilter(b.getAttribute('data-vc-filter')); }); });
      viewBtns.forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-vc-view')); }); });

      if (viewBtns.length) {
        var saved = null;
        try { saved = window.localStorage.getItem('vc-view'); } catch (e) {}
        setView(saved || root.getAttribute('data-default-view') || 'grid');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.vc-pdp').forEach(function (root) {
      var mains = root.querySelectorAll('.vc-pdp__slide');
      var thumbs = root.querySelectorAll('[data-vc-thumb]');
      var gallery = root.querySelector('[data-vc-gallery]');
      var count = mains.length;
      var current = 1;
      function goTo(n) {
        if (!count) return;
        current = ((n - 1 + count) % count) + 1;
        var i = String(current);
        mains.forEach(function (img) { var on = img.getAttribute('data-vc-index') === i; img.hidden = !on; img.classList.toggle('is-active', on); });
        thumbs.forEach(function (b) { var on = b.getAttribute('data-vc-thumb') === i; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-vc-thumb'), 10)); }); });
      var prev = root.querySelector('[data-vc-prev]'), next = root.querySelector('[data-vc-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      if (gallery && count > 1) {
        gallery.setAttribute('tabindex', '0');
        gallery.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { goTo(current - 1); e.preventDefault(); } if (e.key === 'ArrowRight') { goTo(current + 1); e.preventDefault(); } });
        var startX = null;
        gallery.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
        gallery.addEventListener('touchend', function (e) { if (startX === null) return; var dx = e.changedTouches[0].clientX - startX; startX = null; if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1); }, { passive: true });
      }

      var input = root.querySelector('[data-vc-qty-input]');
      var add = root.querySelector('[data-vc-add]');
      var total = root.querySelector('[data-vc-add-total]');
      if (!input) return;
      var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '9', 10);
      var cents = parseInt(add && add.getAttribute('data-price-cents') || '0', 10);
      // Keep the shop's own money format (e.g. €28,00): reuse the symbol placement from the server-rendered total.
      var initial = total ? total.textContent.trim() : '';
      var prefix = (initial.match(/^[^0-9]*/) || [''])[0];
      var suffix = (initial.match(/[^0-9]*$/) || [''])[0];
      var fmt;
      try { fmt = new Intl.NumberFormat(root.getAttribute('data-money-locale') || 'de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); } catch (e) { fmt = null; }
      function clamp(n) { n = isNaN(n) ? min : n; return Math.max(min, Math.min(max, n)); }
      function render() {
        var q = clamp(parseInt(input.value, 10));
        input.value = q;
        if (total && fmt) total.textContent = prefix + fmt.format((cents * q) / 100) + suffix;
      }
      root.querySelector('[data-vc-dec]').addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) - 1); render(); });
      root.querySelector('[data-vc-inc]').addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) + 1); render(); });
      input.addEventListener('change', render);
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-signup-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.vc-popup').forEach(function (root) {
      var dialog = root.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var key = root.getAttribute('data-key') || 'vc-signup-seen';
      var delay = parseInt(root.getAttribute('data-delay') || '12000', 10);
      var posted = /customer_posted=true/.test(window.location.search) && root.querySelector('.vc-popup__done');
      function seen() { try { return !!window.localStorage.getItem(key); } catch (e) { return false; } }
      function markSeen() { try { window.localStorage.setItem(key, '1'); } catch (e) {} }
      function close() { markSeen(); if (dialog.open) dialog.close(); }
      root.querySelectorAll('[data-vc-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
      dialog.addEventListener('cancel', markSeen);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      if (posted) { dialog.showModal(); markSeen(); return; }
      if (root.hasAttribute('data-design-mode') || seen()) return;
      window.setTimeout(function () { if (!seen() && !dialog.open) dialog.showModal(); }, delay);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
